import { matchRoutes, RouteObject } from 'react-router-dom';

export const APPLICATION_NAME = 'DevRain Time Tracking';

type PageTitleRoute = RouteObject & { handle: { pageTitle: string } };

// Keep aligned with App routes. Static labels deliberately exclude record/user data.
export const PAGE_TITLE_ROUTES: PageTitleRoute[] = [
  { path: '/', handle: { pageTitle: 'Dashboard' } },
  { path: '/dashboard', handle: { pageTitle: 'Dashboard' } },
  { path: '/admin-dashboard', handle: { pageTitle: 'Admin dashboard' } },
  { path: '/entries', handle: { pageTitle: 'Entries' } },
  { path: '/api-keys', handle: { pageTitle: 'API keys' } },
  { path: '/calendar', handle: { pageTitle: 'Calendar' } },
  { path: '/weekly', handle: { pageTitle: 'Weekly' } },
  { path: '/reports', handle: { pageTitle: 'Reports' } },
  { path: '/leads', handle: { pageTitle: 'Leads' } },
  { path: '/leads/new', handle: { pageTitle: 'Create Lead' } },
  { path: '/leads/edit/:id', handle: { pageTitle: 'Edit Lead' } },
  { path: '/customers', handle: { pageTitle: 'Customers' } },
  { path: '/dayoffs', handle: { pageTitle: 'Dayoffs' } },
  { path: '/member-time-summary', handle: { pageTitle: 'Member time' } },
  { path: '/deleted-entries', handle: { pageTitle: 'Deleted entries' } },
  { path: '/project-tasks', handle: { pageTitle: 'Project tasks' } },
  { path: '/resource-planning', handle: { pageTitle: 'Resource planning' } },
  { path: '/project-planning', handle: { pageTitle: 'Project planning' } },
  { path: '/admin-api-keys', handle: { pageTitle: 'All API keys' } },
  { path: '/employees', handle: { pageTitle: 'Members' } },
];

export const resolvePageLabel = (pathname: string): string | undefined => {
  const matches = matchRoutes(PAGE_TITLE_ROUTES, pathname);
  return matches?.[matches.length - 1].route.handle.pageTitle;
};

export const resolveDocumentTitle = (
  pathname: string,
  auth: { isLoading: boolean; isAuthenticated: boolean }
): string => {
  // Auth screens replace protected pages without necessarily changing the URL.
  if (auth.isLoading) return APPLICATION_NAME;
  if (!auth.isAuthenticated) return `Sign in - ${APPLICATION_NAME}`;

  const label = resolvePageLabel(pathname);
  return label ? `${label} - ${APPLICATION_NAME}` : APPLICATION_NAME;
};
